var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24123 10.4307L9.99942 12.1782C10.352 12.4015 10.7897 12.0693 10.6851 11.6578L9.8882 8.52295C9.86576 8.43564 9.86842 8.34376 9.89587 8.2579C9.92332 8.17203 9.97445 8.09565 10.0434 8.03755L12.5167 5.97892C12.8417 5.70843 12.674 5.16907 12.2565 5.14197L9.0264 4.93234C8.9394 4.92612 8.85595 4.89532 8.78578 4.84352C8.71561 4.79171 8.66159 4.72104 8.63003 4.63973L7.42535 1.60605C7.39261 1.51975 7.33438 1.44544 7.25841 1.39301C7.18244 1.34058 7.09231 1.3125 7 1.3125C6.90769 1.3125 6.81757 1.34058 6.7416 1.39301C6.66562 1.44544 6.6074 1.51975 6.57465 1.60605L5.36998 4.63973C5.33841 4.72104 5.2844 4.79171 5.21423 4.84352C5.14405 4.89532 5.06061 4.92612 4.97361 4.93234L1.74355 5.14197C1.32601 5.16907 1.15826 5.70843 1.48326 5.97892L3.95662 8.03755C4.02555 8.09565 4.07668 8.17203 4.10413 8.2579C4.13159 8.34376 4.13424 8.43564 4.1118 8.52295L3.37277 11.4301C3.24722 11.924 3.77251 12.3227 4.19559 12.0546L6.75877 10.4307C6.83086 10.3848 6.91455 10.3604 7 10.3604C7.08546 10.3604 7.16914 10.3848 7.24123 10.4307Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.b0b334532832e2682709dee0e340c5d1.svg";
export { ForwardRef as ReactComponent };